import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import React, { memo } from 'react';
import Select, { components } from 'react-select';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MultiSelectInput = function MultiSelectInput(_ref) {
  var onInputChange = _ref.onInputChange,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      inputValue = _ref.inputValue,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      onFocus = _ref.onFocus,
      _onClick = _ref.onClick,
      _ref$hasBorder = _ref.hasBorder,
      hasBorder = _ref$hasBorder === void 0 ? true : _ref$hasBorder,
      placeholder = _ref.placeholder,
      autoFocus = _ref.autoFocus,
      isDisabled = _ref.isDisabled,
      _ref$displayLimit = _ref.displayLimit,
      displayLimit = _ref$displayLimit === void 0 ? 3 : _ref$displayLimit,
      isClearable = _ref.isClearable,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? true : _ref$isSearchable,
      selectRef = _ref.selectRef;
  // return <TextInput id="" onChange={(value) => onInputChange && onInputChange(value)} placeholder={placeholder} />;
  var components = {
    DropdownIndicator: null,
    Control: Control,
    MultiValue: function MultiValue(props) {
      return /*#__PURE__*/_jsx(LimitedChipsContainer, {
        selectProps: props,
        displayLimit: displayLimit
      });
    }
  };
  var classNames = {
    control: function control(state) {
      return "p-2 !rounded-2xl !shadow-none ".concat(hasBorder ? "border-1 !border-gray-400 hover:(!shadow)" : "!border-0", " ").concat(state.isDisabled ? "!bg-white" : "");
    },
    multiValue: function multiValue() {
      return "!bg-primary-50 !text-primary-800 !rounded-lg !p-1.5 !text-sm !font-medium !text-primary-800";
    },
    multiValueRemove: function multiValueRemove() {
      return "hover:(!text-white)";
    },
    multiValueLabel: function multiValueLabel() {
      return "!text-primary-800 !text-sm";
    },
    container: function container() {
      return 'w-full';
    }
  };
  return /*#__PURE__*/_jsx(StyledSelectComponent, {
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      if (_onClick) _onClick(e);
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    children: /*#__PURE__*/_jsx(Select, {
      components: components,
      inputValue: inputValue,
      isClearable: isClearable,
      isSearchable: isSearchable,
      isMulti: true,
      menuIsOpen: false,
      value: value,
      placeholder: placeholder,
      classNames: classNames,
      onChange: onChange,
      onInputChange: onInputChange,
      onKeyDown: onKeyDown,
      onFocus: onFocus,
      autoFocus: autoFocus,
      isDisabled: isDisabled // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ,
      ref: selectRef
    })
  });
};
export default /*#__PURE__*/memo(MultiSelectInput);
var LimitedChipsContainer = /*#__PURE__*/memo(function (_ref2) {
  var selectProps = _ref2.selectProps,
      displayLimit = _ref2.displayLimit;
  var index = selectProps.index,
      getValue = selectProps.getValue;
  var overflow = getValue().slice(displayLimit).map(function (x) {
    return x.label;
  });
  return index < displayLimit ? /*#__PURE__*/_jsx(components.MultiValue, _objectSpread({}, selectProps)) : index === displayLimit ? /*#__PURE__*/_jsx(MoreSelectedBadge, {
    items: overflow
  }) : null;
});

var Control = function Control(_ref3) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/_jsxs(components.Control, _objectSpread(_objectSpread({}, rest), {}, {
    children: [/*#__PURE__*/_jsx(MagnifyingGlassIcon, {
      className: "h-6 w-6 text-gray-900 pl-1"
    }), " ", children]
  }));
};

var MoreSelectedBadge = function MoreSelectedBadge(_ref4) {
  var items = _ref4.items;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: "Altri ".concat(items.length)
  });
};

export var createOption = function createOption(label, value, type) {
  return {
    label: label,
    value: value || label,
    type: type,
    key: 'selected_occupation'
  };
};

var StyledSelectComponent = /*#__PURE__*/_styled.div.withConfig({
  displayName: "multi-select-input__StyledSelectComponent",
  componentId: "sc-123fulz-0"
})(["input{", " ", "}"], {
  ":focus": {
    "--tw-shadow": "0 0 #0000 !important",
    "--tw-shadow-colored": "0 0 #0000 !important",
    "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
    "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
    "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)"
  }
}, {
  "borderStyle": "none",
  "::placeholder": {
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "400"
  }
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "multi-select-input___StyledDiv",
  componentId: "sc-123fulz-1"
})({
  "width": "fit-content",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "padding": "9px",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))"
});